import { configureStore } from "@reduxjs/toolkit";
import consentReducer from "./shared/components/cookie-consent/consentSlice";

export default configureStore({
  reducer: {
    consent: consentReducer,
  },
});
